import { Ajax } from '../helpers/ajax';
import { ElementHelpers } from '../helpers/element-helpers';

export class LazyloadVacancycard {
	constructor(elem, queryParams, searchTerm) {
		this.elem = elem;
		this.endpoint = this.elem.dataset.endpoint;
		this.params = queryParams;
		this.searchTerm = searchTerm;
		this.vacancyCard = this.elem.querySelector('[data-search-vacancycard]');
		this.counter = this.vacancyCard.querySelector('[data-vacancy-counter]');
		this.totalCounter = ElementHelpers.getParentByClass(this.elem, 'search').querySelector('[data-board-counter]');
		this.analyticsLabel = this.vacancyCard.dataset.analyticsLabel;
		this.linkUnit = this.vacancyCard.querySelector('[data-link-unit]');
		this.init();
	}

	init() {
		this.elem.style.opacity = '0.5';
		this.elem.dataset.vacancyResultsLoaded = false;
		this.getData(this.params);
	}

	getData(params) {
		const separator = this.endpoint.indexOf('?') === -1 ? '?' : '&';
		let url = this.endpoint + separator + params;
		Ajax.GET(url).then((results) => {
			this.updateCounter(results);
			this.updateCardUrl(this.searchTerm, results);
			this.updateAnalyticsLabel(results);
			this.vacancyCard.dataset.searchVacancycard = this.hasResults(results) ? 'has-results' : 'no-results';
			this.elem.style.opacity = '1';
		}, () => {
			console.error('Error loading endpoint');
			return false;
		});
	}

	hasResults(amount) {
		return amount !== 0;
	}

	updateCounter(amount) {
		let string = amount === 1 ? this.elem.dataset.singleResult : this.elem.dataset.multipleResult;
		this.counter.innerText = amount + ' ' + string;
		switch (amount) {
			case 1:
				this.linkUnit.innerText = this.elem.dataset.singleResult;
				break;
			case 0:
				this.linkUnit.innerText = this.elem.dataset.noResult;
				break;
			default:
				this.linkUnit.innerText = this.elem.dataset.multipleResult;
				break;
		}

		this.elem.dataset.vacancyResultsLoaded = true;

		const searchResultsElement = ElementHelpers.getParentByClass(this.elem, 'search').querySelector('[data-search-results-loaded]') || '';
		if (searchResultsElement && searchResultsElement.dataset.searchResultsLoaded === 'true') {
			this.totalCounter.innerText = parseInt(this.totalCounter.innerHTML) + amount;
			searchResultsElement.dataset.searchResultsLoaded = false;
		}
	}

	updateCardUrl(term, amount) {
		term = encodeURIComponent(term.trim());
		if (this.vacancyCard.href.indexOf('?') !== -1) {
			this.vacancyCard.href = this.vacancyCard.href.split('?')[0];
		}
		if (this.hasResults(amount)) {
			this.vacancyCard.href = this.vacancyCard.href + '?zoekterm=' + term;
		}
	}

	updateAnalyticsLabel(amount) {
		if (this.vacancyCard.dataset.analyticsLabel.indexOf(' -') !== -1) {
			this.analyticsLabel = this.vacancyCard.dataset.analyticsLabel.split(' -')[0];
		}
		if (this.hasResults(amount)) {
			this.vacancyCard.dataset.analyticsLabel = this.analyticsLabel + ' - heeft resultaten';
		} else {
			this.vacancyCard.dataset.analyticsLabel = this.analyticsLabel + ' - heeft geen resultaten';
		}
	}
}

